import { sv, email, password, mobile } from '#/lib/validation/common';

export const loginSchema = sv.object({
  email: email,
  password: sv.string().min(1).max(64)
});

export const signUpSchema = sv
  .object({
    name: sv.string().max(64),
    password: password,
    confirmPassword: password,
    organization: sv.string().nullable(),
    email: email,
    invite: sv.boolean().default(false).optional(),
    mobile: mobile
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: '비밀번호가 일치하지 않습니다.'
  });

export const ForgotPasswordSchema = sv.object({
  email: email
});

export const authSchema = sv.object({
  name: sv.string().max(64).nullable(),
  password: password,
  email: email,
  adminRoleId: sv.string().nonempty(),
  invite: sv.boolean().default(false).optional(),
  mobile: mobile,
  system: sv.boolean()
});

export type AuthFormValues = sv.infer<typeof authSchema>;
export type LoginFormData = sv.infer<typeof loginSchema>;
export type SignUpFormData = sv.infer<typeof signUpSchema>;
export type ForgotPasswordFormData = sv.infer<typeof ForgotPasswordSchema>;
